import { x } from '@xstyled/styled-components';
import React from 'react';
import { MediaPlayerProvider } from '~/ui/video-player/MediaPlayerProvider';
import { MediaSource } from '~/ui/video-player/mediaSource';
import { VIDEO_POPUP } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { PopupButton } from './components/PopupButton';

interface Props {
  mediaUrl?: string;
  mediaSources?: MediaSource;
  subtitlesUrl?: string;
  snapshotUrl?: string;
  autoPlay?: boolean;
  name?: string;
  body?: string;
  top?: number;
  left?: number;
  title?: number;
  centerOnCoordinates?: boolean;

  /**
   * When true, the popup will prevent the next button from showing until the popup's
   * audio has been played. If there is no audio, opening the popup will unblock.
   */
  blocking?: boolean;
  replay?: boolean;
  isPopupCentered?: boolean;
}

export type VideoPopupDefinition = ItemDefinition<typeof VIDEO_POPUP, Props>;

export class VideoPopup extends Item<typeof VIDEO_POPUP, Props> {
  protected render({
    mediaUrl,
    mediaSources,
    id,
    top,
    left,
    blocking = false,
    subtitlesUrl,
    snapshotUrl,
    title,
    replay = false,
    centerOnCoordinates = false,
    children
  }: RenderProps<Props>) {
    return (
      <x.div
        position="absolute"
        top={`${top}%`}
        left={`${left}%`}
        pointerEvents={centerOnCoordinates ? 'auto' : undefined}
        style={
          centerOnCoordinates
            ? { transform: 'translate(-50%, -50%)' }
            : undefined
        }
      >
        <MediaPlayerProvider>
          <PopupButton
            id={id}
            mediaUrl={mediaUrl}
            mediaSources={mediaSources}
            subtitlesUrl={subtitlesUrl}
            snapshotUrl={snapshotUrl}
            blocking={blocking}
            replay={replay}
            title={title}
            children={children}
          />
        </MediaPlayerProvider>
      </x.div>
    );
  }
}

registry[VIDEO_POPUP] = VideoPopup;
